// extracted by mini-css-extract-plugin
module.exports = {"box":"jgp-2nQ1K","summary":"jgp-1muul"};